import moment from 'moment';

export const getLastDayOfMonth = (year, month) => {
  let date = new Date(year, month, 0);
  return date.getDate();
}
  
export const createTableCell = (allDays, getFullYear, activeMonth) => {
  let arr = [];
  for(let i = 1; i <= allDays; i++) {
    if (i < 10) {
      arr.push(`${getFullYear + '-' + activeMonth + '-' + String('0'+i)}`);
    } else {
      arr.push(`${getFullYear + '-' + activeMonth + '-' + String(i)}`);
    }
  }
  return arr;
}
  
export const monthCurrent = (month) => {
  if (month < 10) {
    return String('0'+month)
  } else {
    return month
  }
}

// SD-1604: временное окно редактирования табеля за сентябрь 2026 — с 01.10.2026 до 02.10.2026 22:00 (UTC+5)
const temporaryEditMonth = '2026-09';
const temporaryEditWindowStart = moment('2026-10-01T00:00:00+05:00');
const temporaryEditWindowEnd = moment('2026-10-02T22:00:00+05:00');

export const isTemporaryEditWindowOpen = () =>
  moment().isBetween(temporaryEditWindowStart, temporaryEditWindowEnd, null, '[)');

export const getTemporaryEditWindowTimeLeft = () => temporaryEditWindowEnd.diff(moment());

export const isTemporaryEditMonth = date => moment(date).format('YYYY-MM') === temporaryEditMonth;
